import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { chequeCollectionService } from '../services/chequeCollection/chequeCollectionService';

const QUERY_KEYS = {
  collections: 'chequeCollections',
  summary: 'chequeCollectionSummary',
  detail: 'chequeCollectionDetail',
};

export const useCollections = (params = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.collections, params],
    queryFn: () => chequeCollectionService.getCollections(params),
    select: (result) => result,
  });
};

export const useCollectionSummary = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.summary],
    queryFn: () => chequeCollectionService.getSummary(),
    select: (result) => result.data,
  });
};

export const useCollectionDetail = (id) => {
  return useQuery({
    queryKey: [QUERY_KEYS.detail, id],
    queryFn: () => chequeCollectionService.getCollectionDetail(id),
    enabled: !!id,
    select: (result) => result.data,
  });
};

export const useWalkinCollection = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request) => chequeCollectionService.walkinCollection(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.collections] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.summary] });
    },
  });
};

export const useDispatchCourier = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request) => chequeCollectionService.dispatchCourier(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.collections] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.summary] });
    },
  });
};

export const useConfirmDelivery = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request) => chequeCollectionService.confirmDelivery(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.collections] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.summary] });
    },
  });
};

export const useMarkReturned = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request) => chequeCollectionService.markReturned(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.collections] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.summary] });
    },
  });
};
